import React from 'react';
import axios from 'axios';
import { getToken } from '../../utils/tokenStorage';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminGroupsTab = ({ groupSupportRequests, adminGroups, onRefresh, mode }) => {
  if (mode === 'support') {
    return (
      <div className="dashboard-content" data-testid="group-support-section">
        <div className="section-header"><h2>Group Support Requests ({groupSupportRequests.length})</h2></div>
        {groupSupportRequests.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>No group support requests yet.</div>
        ) : (
          <table className="admin-table">
            <thead><tr><th>Member</th><th>Type</th><th>Message</th><th>Date</th><th>Status</th><th>Actions</th></tr></thead>
            <tbody>
              {groupSupportRequests.map(req => (
                <tr key={req.request_id} data-testid={`group-support-row-${req.request_id}`}>
                  <td><strong>{req.user_name}</strong><br /><span style={{ fontSize: '12px', color: '#6b7280' }}>{req.user_email}</span></td>
                  <td style={{ textTransform: 'capitalize' }}>{req.request_type || 'General'}</td>
                  <td style={{ maxWidth: '300px', fontSize: '13px' }}>{req.message}</td>
                  <td style={{ fontSize: '13px' }}>{new Date(req.created_at).toLocaleDateString()}</td>
                  <td><span style={{ padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: '600', background: req.status === 'resolved' ? '#d1fae5' : '#fef3c7', color: req.status === 'resolved' ? '#059669' : '#d97706' }}>{req.status}</span></td>
                  <td>
                    {req.status === 'open' && (
                      <button className="btn btn-primary" style={{ padding: '4px 12px', fontSize: '12px' }}
                        onClick={async () => {
                          const token = getToken();
                          const note = prompt('Resolution note (optional):');
                          try {
                            await axios.patch(`${API}/groups/support/${req.request_id}`, { status: 'resolved', resolution_note: note || '' }, { withCredentials: true, headers: { Authorization: `Bearer ${token}` } });
                            onRefresh();
                          } catch { alert('Failed'); }
                        }}>Resolve</button>
                    )}
                    {req.status === 'resolved' && req.resolution_note && (
                      <span style={{ fontSize: '12px', color: '#6b7280' }}>Note: {req.resolution_note}</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    );
  }

  // mode === 'groups' — Property Groups only
  return (
    <div className="dashboard-content" data-testid="manage-groups-section">
      <div className="section-header">
        <h2>All Property Groups ({adminGroups.length})</h2>
        <p>Member housing groups across the platform</p>
      </div>
      {adminGroups.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>No property groups yet. Members create groups from property listings.</div>
      ) : (
        <table className="admin-table">
          <thead><tr><th>Group Name</th><th>Property</th><th>Members</th><th>Status</th><th>Actions</th></tr></thead>
          <tbody>
            {adminGroups.map(group => (
              <tr key={group.group_id} data-testid={`group-row-${group.group_id}`}>
                <td><strong>{group.name}</strong></td>
                <td style={{ fontSize: '13px' }}>{group.property_city ? `${group.property_city}, ${group.property_state}` : 'No property'}</td>
                <td style={{ textAlign: 'center' }}>{group.members?.length || 0} / {group.max_spots || 4}</td>
                <td><span style={{ padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: '600', background: group.status === 'open' ? '#d1fae5' : '#fef3c7', color: group.status === 'open' ? '#059669' : '#d97706' }}>{group.status}</span></td>
                <td><span style={{ fontSize: '12px', color: '#6b7280' }}>{group.group_id?.slice(-8)}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AdminGroupsTab;
